import { createRouter, ErrorComponent } from '@tanstack/react-router';

import { queryClient } from '@/lib/query-client';
import { NotFoundComponent } from '@/components/shared/not-found-component';

import { routeTree } from './route-tree';

function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Failed to load module script') ||
      error.message.includes('Loading chunk') ||
      error.message.includes('Loading CSS chunk')
    );
  }
  return false;
}

export const router = createRouter({
  routeTree,
  defaultPendingComponent: () => (
    <div>
      {/* TODO: create loading for pending component ideal */}
      <p>Loading</p>
    </div>
  ),
  defaultErrorComponent: ({ error }) => {
    if (isChunkLoadError(error)) {
      const reloadKey = 'chunk-reload';
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      if (!lastReload || now - Number(lastReload) > 10000) {
        sessionStorage.setItem(reloadKey, String(now));
        window.location.reload();
        return null;
      }
    }
    return <ErrorComponent error={error} />;
  },
  defaultNotFoundComponent: () => <NotFoundComponent />,
  context: {
    authStore: undefined!,
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

export type AppRoutePath =
  (typeof router)['routesById'][keyof (typeof router)['routesById']]['fullPath'];

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
